import { render, staticRenderFns } from "./LoginOwner copy.vue?vue&type=template&id=31f8526f&lang=true"
import script from "./LoginOwner copy.vue?vue&type=script&lang=js"
export * from "./LoginOwner copy.vue?vue&type=script&lang=js"
import style0 from "./LoginOwner copy.vue?vue&type=style&index=0&id=31f8526f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports